import Handlebars from 'handlebars/dist/handlebars';

(function ($) {
  'use strict';

  var helpers = {
    /**
     * Return sum of two values.
     *
     * @param {number|string} a First value
     * @param {number|string} b Second value
     */
    add: function (a, b) {
      return a + b;
    },
    /**
     * Return result of a mathematical expression.
     *
     * @param {number|string} dynamic
     */
    calculate: function () {
      var expression = '';

      // skip the last argument being a handlebars object
      for (var i = 0; i < arguments.length - 1; ++i) {
        expression = expression + String(arguments[i]);
      }

      return Function(`'use strict'; return (${expression})`)();
    },
    debug: function () {
      /* jshint devel: true */
      console.log({
        this: this,
        arguments: arguments,
      });
    },
    /*
     * Format dates using momentjs.
     * @param {string} date A valid daformatDatete time string.
     * @param {string} format The momentjs format.
     */
    formatDate: function (date, format) {
      format = format || 'lll';
      if (format == 'calendar') return moment(date).calendar();

      var months = moment(Date.now()).diff(moment(date), 'months', true);
      if (months >= 11) format = format + ' YYYY';

      return moment(date).format(format);
    },
    /**
     * Access the given property on the given context.
     *
     * Useful, for example, for looking up values in another structure based on
     * the current @index in a loop, combined with Handlebars's support for
     * subexpressions.
     *
     * @param {object|array} context The object which contains the property.
     * @param {string} property The property name.
     */
    get: function (context, property) {
      return context[property];
    },
    getText: function (context) {
      return context.match(/([A-Z])\w+/g).join(' ');
    },
    item: function (context, options) {
      if (context.length > 0 && context[0] === 'Aqua') {
        // placement colors (multiples of 10 to support more than 10)
        return context[options % 10];
      }
      return context[options];
    },
    json: function (obj) {
      return JSON.stringify(obj);
    },
    lower: function (options) {
      if (!options) return '';

      // Only use this helper when the content is expected to be just text.
      if (typeof options === 'string') return options.toLowerCase();

      var text = options.fn(this);
      return typeof text === 'string' ? text.toLowerCase() : '';
    },
    /**
     * Inject a partial of the given name, feeding it with a context and/or
     * key/value pairs.
     *
     * Note that key/value pairs will overwrite keys of the same name in the
     * passed-in context.
     *
     * Because our partials and templates live in the same namespace, this
     * could technically inject a template as well. The difference is that
     * partials tend to expect relatively flat, simple data, whereas templates
     * tend to iterate over complex structures, while referencing shallower
     * properties.
     *
     * This helper makes it easy to pass arbitrary flat structures to the
     * partial.
     *
     * Example usages:
     *     {{{partial 'button' name=name handler=../action}}}
     *     {{{partial 'button' @root example=true}}}
     *     {{{partial 'button' this}}}
     */
    partial: function (name, context, options) {
      if (options === undefined) {
        options = context;
        context = {};
      }

      $.extend(context, options.hash);
      return Gryphon.templates[name](context);
    },
    reverseArray: function (array) {
      return array.reverse();
    },
    splitItem: function (str, separator, index, options) {
      return str.split(separator)[parseInt(index)] || '';
    },
    upper: function (options) {
      if (!options) return '';

      // Only use this helper when the content is expected to be just text.
      if (typeof options === 'string') return options.toUpperCase();

      var text = options.fn(this);
      return typeof text === 'string' ? text.toUpperCase() : '';
    },
  };
  window.helpers = { ...window.helpers, ...helpers };

  // Attach all the helper functions to the Handlebars namespace.
  for (var name in helpers) {
    if (Object.prototype.hasOwnProperty.call(helpers, name))
      Handlebars.registerHelper(name, helpers[name]);
  }
})(jQuery);
